import "./Contact.module.css";
import Navigation from "@/reusable_sections/Header";
import Inquiry from "./sections/Inquiry";
import Channels from "./sections/Channels";
import FinalThought from "./sections/FinalThought";
import Footer from "@/reusable_sections/Footer";
export default function ContactPage() {
  return <div>
      <Navigation />
      <Inquiry />
      <Channels />
      <FinalThought />
      <Footer />
    </div>;
}